export default {"src":"/_next/static/media/my-favorites-details-red-heart.a1d6c87f.svg","height":40,"width":98,"blurWidth":0,"blurHeight":0};